{
	"renameProjectTitle": "Rename Project",
	"updatingProject": "Updating project..."
}
